import { createContext, useContext } from 'react'
import { useAuth } from 'lib/auth'

export const INACTIVE_REGISTRATION_INVITE = {
  isValid: false,
  token: null,
  firstName: '',
  lastName: '',
  email: '',
}

export const RegistrationInviteContext = createContext(
  INACTIVE_REGISTRATION_INVITE,
)

export const useRegistrationInvite = () => useContext(RegistrationInviteContext)

export const INVITE_EMAIL_MISMATCH_MESSAGE =
  'This invitation was sent to a different email address. Sign out and open the invite link again, or use the invited email.'

export const emailsMatch = (a, b) =>
  (a || '').trim().toLowerCase() === (b || '').trim().toLowerCase()

export const useInviteEmailMismatch = () => {
  const { isValid, email } = useRegistrationInvite()
  const { user, isConsumer } = useAuth()
  return Boolean(
    isValid && user && isConsumer && !emailsMatch(user.email, email),
  )
}
